import { render, staticRenderFns } from "./ForumLevel.vue?vue&type=template&id=525da665&scoped=true"
import script from "./ForumLevel.vue?vue&type=script&lang=js"
export * from "./ForumLevel.vue?vue&type=script&lang=js"
import style0 from "./ForumLevel.vue?vue&type=style&index=0&id=525da665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525da665",
  null
  
)

export default component.exports